import Vue from 'vue'
import VueRouter from 'vue-router'
import MusicPlayer from '@/components/MusicPlayer'

Vue.use(VueRouter)

document.title = 'Platinum Couch Productions'

const routes = [
  {
    path: '/',
    component: MusicPlayer,
  },
  {
    // Poll results — must precede /:playlistID so it isn't matched as a playlist
    path: '/poll/:hash',
    component: MusicPlayer,
    props: route => ({ pollResultsHash: route.params.hash }),
  },
  {
    path: '/:playlistID',
    component: MusicPlayer,
    props: true,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router